import { render, staticRenderFns } from "./UnidadeConservacao.vue?vue&type=template&id=82468f0e&lang=pug"
import script from "./UnidadeConservacao.vue?vue&type=script&lang=js"
export * from "./UnidadeConservacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports